import { onUnmounted } from 'vue';

export default function useWindowResize(onResize: () => void) {
  const resize = () => {
    onResize();
  };
  window.addEventListener('resize', resize);
  onUnmounted(() => {
    window.removeEventListener('resize', resize);
  });
}
